import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BannerImage from "../../assets/images/imageAbout.jpg";
import SignInModal from "../Modals/signInModal";               // adjust path
import { initializeAOS } from "../../Aos";

const HeroBanner = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeModal, setActiveModal] = useState(null);

  useEffect(() => {
    initializeAOS();
  }, []);

  return (
    <>
      <section className="pt-[90px] pb-[70px] bg-[#D9F4EF]">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

            {/* LEFT CONTENT */}
            <div data-aos="fade-right">
              {/* Badge */}
              <span className="inline-flex items-center gap-2 px-4 py-1 mb-5 text-sm font-medium bg-white rounded-full text-[#3F465D]">
                <span className="w-2 h-2 bg-[#2CC7A3] rounded-full"></span>
                Step-by-step process
              </span>

              {/* Heading */}
              <h1 className="text-[#1F2937] text-4xl lg:text-5xl font-semibold leading-tight mb-5">
                How invoice discounting works
                <br />
                <span className="text-[#1F2937]">with Invexflow</span>
              </h1>

              {/* Description */}
              <p className="text-[#6B7280] text-lg max-w-xl mb-8">
                A clear, transparent flow from connecting your invoices to
                receiving funds and settling when your customer pays.
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-wrap items-center gap-4">
                {/* <button
                  onClick={() => {
                    setActiveModal("signin");
                    setMobileOpen(false);
                  }}
                  className="bg-[#2CC7A3] hover:bg-[#26b392] transition text-white px-6 py-3 rounded-lg font-semibold"
                >
                  Start Free Assessment
                </button> */}

                {/* <a
                href="#"
                className="bg-white text-[#374151] px-6 py-3 rounded-lg font-semibold border border-gray-200 hover:bg-gray-50 transition"
              >
                Download PDF
              </a> */}
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div data-aos="fade-left" className="flex justify-center">
              <div className="bg-white rounded-xl shadow-md p-4 max-w-lg w-full">
                <img
                  src={BannerImage}
                  alt="Invoice Discounting"
                  className="rounded-lg w-full object-cover"
                />
              </div>
            </div>

          </div>
        </div>
      </section>
      {
        activeModal === "signin" && (
          <SignInModal
            onClose={() => setActiveModal(null)}
            onSwitchToSignUp={() => setActiveModal("signup")}
          />
        )
      }
    </>
  );
};

export default HeroBanner;
